import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = () => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-wrapper">
        <Header onSearch={setSearchQuery} />
        <div className="content">
          <Outlet context={{ searchQuery }} />
        </div>
      </div>
    </div>
  );
};

export default Layout;
